import React from "react";
import './login.css';
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import LoginComponent from "./login.component";
import FooterComponent from "../footer/footer";
import { Helmet } from "react-helmet-async";




const LoginFormComponent = () => {
  return (
    <>
          <Helmet>
             <title>LOGIN SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
              <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
              <meta name="robots" content="index, follow" />
          </Helmet>
       <HeaderComponent/> 
       <NavbarComponent/>
      <section  id="fixed-sub-nav" className="vh-100 gradient-background">
       <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
          <div className="col-lg-6 col-md-8 col-12  mt-2 pt-1">
               <LoginComponent/>
             </div>
          </div>



        </div>

      </section>


          <FooterComponent/>

    </>
  );
};

export default LoginFormComponent;